import React from 'react';

import { CalendarComponent } from '../components/Calendar';
import { connect } from 'react-redux';

import {
    clickDay,
    hoverDay,
    nextMonth,
    prevMonth,
} from '../actions';


var CalendarSelectView = (props) => {
	let { calendar } = props;
    let { nextMonth, prevMonth, clickDay, hoverDay } = props;

    let onClick = function(day) {
        clickDay(day);
        if ( props.onClick ) {
            props.onClick(day.date);
        }
    };

    let onHover = function(day) {
        if ( calendar.selecting ) {
            hoverDay(day);
        }
    };

	return (
		<div className="calendar-view">
            <CalendarComponent {...calendar} onClick={onClick} onHover={onHover} prevMonth={prevMonth}  />
            <CalendarComponent {...calendar} onClick={onClick} onHover={onHover} nextMonth={nextMonth} offset={1} />
            <div className="clear" />
		</div>
	);
}


const mapStateToProps = (state) => ({
    calendar: state.calendar,
})

const mapDispatchToProps = (dispatch) => ({
    prevMonth: _ => dispatch(prevMonth()),
    nextMonth: _ => dispatch(nextMonth()),
    clickDay: day => dispatch(clickDay(day.date)),
    hoverDay: day => dispatch(hoverDay(day.date)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CalendarSelectView);




/** WEBPACK FOOTER **
 ** ../ibe/views/CalendarSelectView.js
 **/